var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefferal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0238 10.123C24.9121 10.1307 24.7998 10.1195 24.6879 10.1195V10.1195C24.5759 10.1195 24.4636 10.1307 24.352 10.123C21.9571 9.95906 20.0817 7.96726 20.0817 5.53331C20.0817 2.99475 22.1413 0.919189 24.6959 0.919189C27.2344 0.919189 29.31 2.97878 29.31 5.53331C29.2944 7.96726 27.4186 9.95906 25.0238 10.123Z",
    fill: "#02243D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0605 21.1958C29.312 21.6971 28.4375 22.0668 27.504 22.3051C25.542 22.8058 24.3017 20.6115 24.3838 18.5882C24.3885 18.4734 24.3914 18.358 24.3926 18.2422C24.3926 18.1152 24.3904 17.9887 24.386 17.8628C24.3134 15.8007 25.5589 13.5196 27.5549 14.0421C28.4629 14.2798 29.3116 14.6424 30.0445 15.1288C32.5671 16.7893 32.5671 19.5194 30.0605 21.1958Z",
    fill: "#02243D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98094 10.123C7.09261 10.1307 7.20491 10.1195 7.31684 10.1195V10.1195C7.42876 10.1195 7.54106 10.1307 7.65273 10.123C10.0476 9.95906 11.923 7.96726 11.923 5.53331C11.923 2.99475 9.86339 0.919189 7.30886 0.919189C4.77029 0.919189 2.69473 2.97878 2.69473 5.53331C2.71034 7.96726 4.58606 9.95906 6.98094 10.123Z",
    fill: "#02243D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32516 18.2421C7.32516 18.3454 7.32665 18.4483 7.32962 18.5509C7.38883 20.5997 6.10445 22.8048 4.14085 22.217C3.34516 21.9788 2.59996 21.6425 1.94468 21.2117C-0.577915 19.5353 -0.577915 16.8051 1.94468 15.1287C2.58625 14.697 3.32688 14.3621 4.12178 14.1258C6.10893 13.5349 7.40104 15.8 7.33137 17.872C7.32724 17.9948 7.32516 18.1181 7.32516 18.2421Z",
    fill: "#02243D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_23_1807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2177 23.0637C16.09 23.0478 15.9463 23.0478 15.8026 23.0637C12.8649 22.9679 10.5179 20.5571 10.5179 17.5875C10.5179 14.554 12.9607 12.0952 16.0102 12.0952C19.0437 12.0952 21.5024 14.554 21.5024 17.5875C21.5024 20.5571 19.1714 22.9679 16.2177 23.0637Z",
    fill: "#24BCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 26.3687C8.61799 27.9812 8.61799 30.6316 11.0288 32.2281C13.775 34.0642 18.2773 34.0642 21.0234 32.2281C23.4343 30.6156 23.4343 27.9653 21.0234 26.3687C18.2933 24.5326 13.7909 24.5326 11.0288 26.3687Z",
    fill: "#24BCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_23_1807",
    x: 9.2207,
    y: 12.0952,
    width: 13.6113,
    height: 23.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.737255 0 0 0 0 0.992157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_23_1807"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferal);
export default __webpack_public_path__ + "static/media/refferal.0d63248e80ffccbf3d6e35efe014c729.svg";
export { ForwardRef as ReactComponent };